export function getCalendarSectionFilters({
  building,
  include_cancelled_appointments,
  include_done_tasks,
  sources,
}) {
  return {
    building_id: building?.id,
    include_cancelled_appointments,
    include_done_tasks,
    sources,
  }
}
